import React from "react";
import Testimonials from "./Testimonials";
import CallToAction from "./CallToAction";
import styles from "./css/TestimonialsAndCTA.module.css";

const TestimonialsAndCTA = () => {
  return (
    <div className={styles.testimonialsAndCtaWrapper}>
      <Testimonials />
      <CallToAction />
    </div>
  );
};

export default TestimonialsAndCTA;
